
const URL = "https://social-media-api-wpye.onrender.com";

export default URL;